/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgToolbarCopy: React.FC<React.SVGAttributes<SVGElement>> = (
    props
) => (
    <svg viewBox="0 0 20 20" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="currentColor"
                d="M16 5a1 1 0 011 1v11a1 1 0 01-1 1H7a1 1 0 01-1-1V6a1 1 0 011-1h9zm-.5 1.5h-8v10h8v-10zM10.25 2a.75.75 0 01.102 1.493l-.102.007H4.5v11.25a.75.75 0 01-.648.743l-.102.007a.75.75 0 01-.743-.648L3 14.75V3.25c0-.647.492-1.18 1.122-1.244L4.25 2h6z"
            />
            <path d="M0 0h20v20H0z" />
        </g>
    </svg>
);
